import { AuthSection, LoginForm } from 'src/Sections';

export const LoginPage = () => {
  return (
    <AuthSection title='Login' subtitle='What are you waiting for!'>
      <LoginForm />
    </AuthSection>
  );
};
